import api from '../../api/index';
import config from '@/assets/config.json';
import router from "../../router/index"; 
 
const state = {
	userRegist:{}
}
const mutations = {
   setUserRegist(state,data){
     state.userRegist=data;
   }
}
const getters = {
	getUserRegist: state => {
		return state.userRegist;
	}
}

const actions = {
//OA登录
	OA_MobilePhone({ rootState, commit },opt) { 
		return new Promise((resolve, reject) => {
			api.post(`${config.BJLogin.api}/api/usertoken`,opt).then(data => {
				
			if (data) {
					resolve(data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},
//手机号码是否存在
	Exist_MobilePhone({ rootState, commit },opt) { 
		return new Promise((resolve, reject) => {//获取手机验证码
			api.post(`${config.BJLogin.api}/Auth/CheckPhone`,opt).then(data => {
				
			if (data) {
					resolve(data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},
//验证码验证
Exist_Code({ rootState, commit },opt) { 
		return new Promise((resolve, reject) => {		
			api.post(`${config.BJLogin.api}/F_UserInfo/VerificationCode`,opt,{ Authorization:'Bearer ' + window.sessionStorage.getItem('token') }).then(data => {
				if (data) {
					resolve(data);
				}
			}).catch((err) => {
				console.log(err,'err');
			});
		});
	},
	//获取手机验证码
	getPhoneCode({ rootState, commit },opt) { 
		return new Promise((resolve, reject) => {
			api.post(`${config.BJLogin.api}/Auth/APPSendCode`,opt).then(data => {
				if (data) {
					resolve(data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},
	//添加注册
	PhoneAdd({ rootState, commit },opt) { 
		return new Promise((resolve, reject) => {
			api.post(`${config.BJLogin.api}/F_UserInfo/SHAdd`,opt,{ Authorization:'Bearer ' + window.sessionStorage.getItem('token') }).then(data => {
				if (data) {
					resolve(data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},
	//获取token
	PhoneToken({ rootState, commit },opt) { 
		return new Promise((resolve, reject) => {
			api.post(`${config.BJLogin.api}/Auth/GetToken`,opt).then(data => {
				if (data) {
					resolve(data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},
	//已注册获取的token
	TokenByPhone({ rootState, commit },opt) { 
		return new Promise((resolve, reject) => {
			api.post(`${config.BJLogin.api}/Auth/GetTokenByPhone`,opt).then(data => {
				if (data) {
					resolve(data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},
	//获取待商户入驻、开店、店铺申诉、开通支付等状态
	shopstat({ rootState, commit },opt) { 
		return new Promise((resolve, reject) => {
			api.get(`${config.BJapi1.api}/apistore-entry/check/audit/stat`,{  params: opt},{ Authorization:'Bearer ' + window.sessionStorage.getItem('usertoken') }).then(data => {
				if (data) {
					resolve(data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},
	//提交资质
	credentialsSave({ rootState, commit },opt) { 
		return new Promise((resolve, reject) => {
			api.post(`${config.BJapi1.api}/apistore-entry/credentials/save`,opt,{ Authorization:'Bearer ' + window.sessionStorage.getItem('usertoken') }).then(data => {
				if (data) {
					resolve(data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},
	//资质获取证件资料
	credentialsGetidtype({ rootState, commit },opt) { 
		return new Promise((resolve, reject) => {
			api.get(`${config.BJapi1.api}/apistore-entry/credentials/getidtype`,opt,{ Authorization:'Bearer ' + window.sessionStorage.getItem('usertoken') }).then(data => {
				if (data) {
					resolve(data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},
	//获取资质
	getCredentials({ rootState, commit },opt) { 
		return new Promise((resolve, reject) => {
			api.get(`${config.BJapi1.api}/apistore-entry/credentials/getbyuid`,{
                params: opt
            },{ Authorization:'Bearer ' + window.sessionStorage.getItem('usertoken') }).then(data => {
				if (data) {
					resolve(data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},
	//获类目
	getCredentialsDoods({ rootState, commit },opt) { 
		return new Promise((resolve, reject) => {
			api.get(`${config.BJapi1.api}/apistore-entry/category-brand/goods?name=${opt.name}`,{ Authorization:'Bearer ' + window.sessionStorage.getItem('usertoken') }).then(data => {
				if (data) {
					resolve(data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},
	//已注册获取的token
	TokenByPhone({ rootState, commit },opt) { 
		return new Promise((resolve, reject) => {
			api.post(`${config.BJLogin.api}/Auth/GetTokenByPhone`,opt).then(data => {
				if (data) {
					resolve(data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},













	checkPhoneCode({ rootState, commit },opt) { //核对手机验证码
		return new Promise((resolve, reject) => {
			api.post(`${config.https.api}/apiuser/login/checkcode`,opt).then(data => {
				if (data.data) {
					resolve(data.data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},
	checkPlatem({ rootState, commit },opt) { //检测手机号码是否是平台
		return new Promise((resolve, reject) => {
			api.post(`${config.https.api}/apiuser/login/isuser`,opt).then(data => {
				if (data.data) {
					resolve(data.data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},
	uploadBase64({ rootState, commit },opt) { //上传图片
		return new Promise((resolve, reject) => {
			api.post(`${config.staticPro.api}/api/filesup/files`,opt).then(data => {
				if (data) {
					resolve(data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},
	getImgInfo({ rootState, commit },opt) { //获取
		return new Promise((resolve, reject) => {
			api.get(`${config.newhttps.api}/wx/getImgInfo`,opt).then(data => {
				if (data.data) {
					resolve(data.data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},
	buyerSettle({ rootState, commit },opt) { //商家入驻/apimerchant/users/register
		return new Promise((resolve, reject) => {
			api.post(`${config.https.api}/apimerchant/users/register`,opt,{Authorization: ` Bearer ${window.sessionStorage.getItem('usertoken')}`}).then(data => {
				if (data.data) {
					resolve(data.data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},
  
	companyInfo({ rootState, commit },opt) { //apimerchant/users/company/info
		return new Promise((resolve, reject) => {
			api.post(`${config.https.api}/apimerchant/users/company/info`,opt).then(data => {
				if (data.data) {
					resolve(data.data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},
	getSettleUser({ rootState, commit },opt) { //审核失败获取用户信息
		return new Promise((resolve, reject) => {
			api.post(`${config.https.api}/apimerchant/users/getinfos`,opt).then(data => {
				if (data.data) {
					resolve(data.data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},
	outLogin({ rootState, commit },opt) { //退出登入
		return new Promise((resolve, reject) => {
			api.post(`${config.https.api}/apiuser/login/logout`,opt).then(data => {
				if (data.data) {
					resolve(data.data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},
	updateSettle({ rootState, commit },opt) { //审核失败修改
		return new Promise((resolve, reject) => {
			api.post(`${config.https.api}/apimerchant/users/updateinfo`,opt).then(data => {
				if (data.data) {
					resolve(data.data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},
	getRecommend({ rootState, commit }) { //获取推荐人信息
		return new Promise((resolve, reject) => {
			api.post(`${config.https.api}/apimerchant/users/getreferrer`).then(data => {
				if (data.data) {
					resolve(data.data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	},
	getBusinessLicense({ rootState, commit },opt) { //获取上传之后的营业执照信息
		return new Promise((resolve, reject) => {
			api.get(`${config.newHttps.api}/merchant/v2/ocr/business-license`,opt,{Authorization: ` Bearer ${window.sessionStorage.getItem('usertoken')}`}).then(data => {
				if (data) {
					resolve(data);
				}
			}).catch((err) => {
				resolve(err);
			});
		});
	},
	getIDCard({ rootState, commit },opt) { //获取上传之后的营业执照信息
		return new Promise((resolve, reject) => {
			api.get(`${config.newHttps.api}/merchant/v2/ocr/id-card-front`,opt,{Authorization: ` Bearer ${window.sessionStorage.getItem('usertoken')}`}).then(data => {
				if (data.data) {
					resolve(data);
				}
			}).catch((err) => {
				console.log(err);
			});
		});
	}
	
	
}
export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters,
}


// WEBPACK FOOTER //
// ./src/store/settle/product.js